export const MODES = {
  /** если нет маршрута/трансфера Kiwitaxi */
  NO_RESULTS: 'no-results',
  /** есть трансферы Kiwitaxi, продаж не было */
  NO_SALES: 'no-sales',
  /** нет трансферов, подходящих по вместимости */
  NO_CAPACITY: 'no-capacity',
};

export const LANGUAGE_MAP = {
  en: {
    api: 'en-US',
    app: 'en-us',
  },
  ru: {
    api: 'ru-RU',
    app: 'ru-ru',
  },
  de: {
    api: 'de-DE',
    app: 'de-de',
  },
  fr: {
    api: 'fr-FR',
    app: 'fr-fr',
  },
  es: {
    api: 'es-ES',
    app: 'es-es',
  },
  pt: {
    api: 'pt-PT',
    app: 'pt-pt',
  },
  pl: {
    api: 'pl-PL',
    app: 'en-en',
  },
  hu: {
    api: 'en-US',
    app: 'en-en',
  },
  it: {
    api: 'it-IT',
    app: 'it-it',
  },
  nl: {
    api: 'en-US',
    app: 'en-en',
  },
  ua: {
    api: 'uk-UA',
    app: 'en-en',
  },
};

export const SEARCH_RESULT_ERROR_TYPES = {
  ROUTE_NO_TRANSFERS: 'ROUTE_NO_TRANSFERS',
  ROUTE_NO_RESULT: 'ROUTE_NO_RESULT',
  ROUTE_AND_MOZIO_NO_TRANSFERS: 'ROUTE_AND_MOZIO_NO_TRANSFERS',
};
